import React, { FC } from 'react';
import {
  faCalendar,
  faMoon,
  faPlane,
  faSnowflake,
  faUser,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { dateFormat } from '@bepro-travel/fe.utils';
import { Deal } from '../../ts/interfaces/OphirBook';

interface SummaryCardProps {
  deal: Deal;
  nights: number;
}

const SummaryCard: FC<SummaryCardProps> = ({ deal, ...props }) => {
  const [t] = useTranslation() as unknown as [(key: string) => string];
  return (
    <div
      className="default-shadow mt-30 text-lh"
      style={{ overflow: 'hidden', background: 'var(--color-bg-light)' }}
    >
      <div className="oph-table-sm-title mb-10">
        <span
          className="name"
          dangerouslySetInnerHTML={{ __html: deal.hotels?.[0].name.desc || '' }}
        ></span>
      </div>
      <div className="mb-10">
        <FontAwesomeIcon icon={faCalendar as any} className="mr-5 ml-10" />
        {t('op.check_in')}: {dateFormat(deal.package.startDate, 'EEEE - MMMM dd, yyyy')}
      </div>
      <div className="mb-10">
        <FontAwesomeIcon icon={faCalendar as any} className="mr-5 ml-10" />
        {t('op.check_out')}: {dateFormat(deal.package.endDate, 'EEEE - MMMM dd, yyyy')}
      </div>
      <div className="mb-10">
        <FontAwesomeIcon icon={faPlane as any} className="mr-5 ml-10" />
        {t('op.airport')}:{' '}
        <span
          dangerouslySetInnerHTML={{ __html: deal.flights?.[0].legs?.[0].departureLocation.name }}
        ></span>{' '}
        , {deal.flights?.[0].legs?.[0].departureLocation.code}
      </div>
      <div className="mb-10">
        <FontAwesomeIcon icon={faMoon as any} className="mr-5 ml-10" />
        {t('op.numb_of_nights')}: {props.nights}
      </div>
      {deal.suppliments?.map((sup: any) => (
        <div className="mb-10">
          <FontAwesomeIcon icon={faSnowflake as any} className="mr-5 ml-10" />
          <span>{sup.nameLoc || sup.name}</span>
        </div>
      ))}
      {deal.package?.flGuideName1 && (
        <div className="mb-10">
          <FontAwesomeIcon icon={faUser as any} className="mr-5 ml-10" />
          {deal.package.flGuideName1}
        </div>
      )}
    </div>
  );
};

export default SummaryCard;
